import { useState, useEffect } from 'react'

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine)
  const [justBack, setJustBack] = useState(false)

  useEffect(() => {
    function onOnline() {
      setOffline(false)
      setJustBack(true)
      const t = setTimeout(() => setJustBack(false), 3000)
      return () => clearTimeout(t)
    }
    function onOffline() {
      setOffline(true)
      setJustBack(false)
    }
    window.addEventListener('online',  onOnline)
    window.addEventListener('offline', onOffline)
    return () => {
      window.removeEventListener('online',  onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  if (!offline && !justBack) return null

  return (
    <div
      className="fixed top-16 left-0 right-0 z-[70] flex items-center justify-center px-4 py-2 pointer-events-none"
      style={{
        background: justBack
          ? 'rgba(57,255,20,0.85)'
          : 'rgba(191,0,255,0.85)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <span className="font-display font-bold text-xs text-white tracking-wider">
        {justBack ? '✅ Back online' : '📵 You\'re offline — showing cached data'}
      </span>
    </div>
  )
}
